import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TeacherLineHistoryRow {
  id: number;
  teacher_code: string;
  old_user_id: string | null;
  old_line_name: string | null;
  new_user_id: string | null;
  new_line_name: string | null;
  created_at: string;
}

export function useTeacherLineHistory(teacherCode: string | null) {
  return useQuery({
    queryKey: ['teacher-line-history', teacherCode],
    enabled: !!teacherCode,
    queryFn: async (): Promise<TeacherLineHistoryRow[]> => {
      const client = supabase.schema('teacher' as any) as any;
      const { data, error } = await client
        .from('line_user_id_log')
        .select('id, teacher_code, old_user_id, old_line_name, new_user_id, new_line_name, created_at')
        .eq('teacher_code', teacherCode)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data || []) as TeacherLineHistoryRow[];
    },
  });
}
